var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-icon-wrap",style:(_vm.wrapStyle)},[_c('Icon',{staticClass:"play-icon",attrs:{"size":_vm.iconSize,"type":"play"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }